import Person from './Person'

export default Person
